'use client';
export default function BgColor({ bgColor }: { bgColor: string }) {
  return (
    <>
      <style>
        {bgColor &&
          `
            body {
              background-color: ${bgColor};
            }
        `}
      </style>
    </>
  );
}
